module.exports = __webpack_public_path__ + "008c7bc7.png";